import React, { FC } from 'react';
import { Box, BoxProps } from '@mui/material';
import { withHighLight } from 'hoc/with-high-light';

const BoxComponent: FC<BoxProps> = ({ children, ...props }: BoxProps) => <Box {...props}>{children}</Box>;

const BoxWithHighLighting: FC<{ data: string; originalData: string } & BoxProps> = withHighLight(BoxComponent);
export default BoxWithHighLighting;
